import { Link } from "react-router-dom";

const stats = [
  { value: "12,000+", label: "收录影视作品" },
  { value: "3,500+", label: "精选影片推荐" },
  { value: "每日更新", label: "影视资讯动态" },
];

export default function AboutBrief() {
  return (
    <section className="w-full rounded-xl bg-secondary-50 border border-secondary-100 overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
        <div className="p-8 md:p-10">
          <span className="inline-block px-3 py-1 rounded-md bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            关于蜜月TV
          </span>
          <h2 className="text-xl md:text-2xl font-black text-foreground-950 mb-3">
            你的观影决策好帮手
          </h2>
          <p className="text-sm text-foreground-600 leading-relaxed mb-5">
            蜜月TV 致力于为影视爱好者提供权威的影视资讯、丰富的影片推荐与详细的影视资料。
            无论是追剧还是选片，我们希望通过清晰的信息层级与轻松的浏览体验，帮你在海量内容中快速找到想看的作品。
          </p>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 whitespace-nowrap px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer"
          >
            了解更多 <i className="ri-arrow-right-line" />
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-1 lg:divide-x-0 divide-y divide-secondary-100 lg:divide-y">
          {stats.map((stat, index) => (
            <div
              key={stat.label}
              className={`flex flex-col justify-center px-8 py-6 ${index === 0 ? "bg-secondary-100/60" : "bg-secondary-50"}`}
            >
              <span className="text-2xl md:text-3xl font-black text-primary-700">{stat.value}</span>
              <span className="text-sm text-foreground-500 mt-1.5">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}